module.exports = __webpack_public_path__ + "static/media/icpbrasillogo.e46d4112.jpeg";